document.addEventListener('DOMContentLoaded', () => {
  const drawerWrap = document.querySelector('header-drawer');
  if (!drawerWrap) return;

  const details = drawerWrap.querySelector('details');
  const drawer  = drawerWrap.querySelector('#menu-drawer');
  const header  = document.querySelector('.header');
  if (!details || !drawer || !header) return;

  const GAP = 8;
  let shadowEl = null;

  // Create and manage shadow
  function ensureShadow() {
    if (!shadowEl) {
      shadowEl = document.createElement('div');
      shadowEl.id = 'menu-shadow';
      shadowEl.style.position = 'fixed';
      shadowEl.style.pointerEvents = 'none';
      shadowEl.style.borderRadius = '16px';
      shadowEl.style.filter = 'blur(0px) drop-shadow(0 20px 45px rgba(0,0,0,0.35))';
      shadowEl.style.transition = 'opacity .25s ease';
      shadowEl.style.zIndex = '2147483646'; // just under the drawer
      shadowEl.style.opacity = '0';
      document.body.appendChild(shadowEl);
    }
  }

  function placeShadow() {
    if (!shadowEl || !drawer.isConnected) return;
    const r = drawer.getBoundingClientRect();
    shadowEl.style.left = `${r.left}px`;
    shadowEl.style.top = `${r.top}px`;
    shadowEl.style.width = `${r.width}px`;
    shadowEl.style.height = `${r.height}px`;
  }

  function showShadow() {
    ensureShadow();
    placeShadow();
    shadowEl.style.opacity = '1';
  }

  function hideShadow() {
    if (shadowEl) shadowEl.style.opacity = '0';
  }

  // Move drawer outside the header pill
  function portDrawer() {
    if (drawer.parentElement !== document.body) {
      drawer.dataset.ported = '1';
      document.body.appendChild(drawer);
    }
  }

  function placeDropdown() {
    const r = header.getBoundingClientRect();
    const w = Math.min(r.width - 24, Math.round(window.innerWidth * 0.92));
    drawer.style.setProperty('--drawer-left',  Math.round(r.left + 12) + 'px');
    drawer.style.setProperty('--drawer-top',   Math.round(r.bottom + GAP) + 'px');
    drawer.style.setProperty('--drawer-w',     w + 'px');
    drawer.style.left  = `var(--drawer-left)`;
    drawer.style.top   = `var(--drawer-top)`;
    drawer.style.width = `var(--drawer-w)`;
    requestAnimationFrame(placeShadow);
  }

  function openDrawer() {
    portDrawer();
    ensureShadow();
    drawer.classList.remove('is-closing');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    placeDropdown();
    showShadow();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    hideShadow(); 
    setTimeout(() => {
      if (details.open) details.removeAttribute('open');
      drawer.classList.remove('is-closing');
    }, 300);
  }

  // Toggle button (hamburger)
  const toggleBtn =
    drawerWrap.querySelector('button[aria-controls="menu-drawer"]') ||
    drawerWrap.querySelector('summary.header__icon');

  if (toggleBtn) {
    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (details.open) {
        closeDrawer();
      } else {
        details.setAttribute('open', '');
        openDrawer();
      }
    });
  }

  // Maintain position on resize/scroll
  window.addEventListener('resize', () => details.open && placeDropdown());
  window.addEventListener('scroll',  () => details.open && placeDropdown());

  details.addEventListener('toggle', () => {
    if (!details.open) {
      drawer.classList.remove('is-open');
      hideShadow();
    }
  });
});

